import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IAIWorkspaceRequest } from "../types";
import { BackednResponse } from "@shared/lib/types";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useReanalyzeCreatorFitRequest(onSuccess?: (data: BackednResponse<IAIWorkspaceRequest>) => void) {
  const reanalyzeCreatorFitRequest = useCallback(
    (payload: { aiWorkspaceRequestId: string; creatorFitCheckId: string }) =>
      AiWorkspaceService.reanalyzeCreatorFitCheck(payload)
        .then((res) => {
          ToastService.success("Creator Fit check queued for re-analysis");
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to re-analyze Creator Fit check";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          ToastService.error(errorMessage);
          throw err;
        }),
    []
  );

  const {
    mutate: reanalyze,
    isLoading: isReanalyzing,
    isSuccess: isReanalyzed,
  } = useMutation<{ aiWorkspaceRequestId: string; creatorFitCheckId: string }, BackednResponse<IAIWorkspaceRequest>>({
    mutationFn: reanalyzeCreatorFitRequest,
    options: QUERY_OPTIONS,
    onSuccess: (c, data) => {
      c.invalidateQueries({queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS]});
      c.invalidateQueries({queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUEST]});
      onSuccess?.(data);
    },
  });

  return { reanalyze, isReanalyzing, isReanalyzed };
}
